const t = "Abgeschlossener Schritt", e = "Zurück zu {buttonName}", o = "Weiter zu {buttonName}", n = {
  completedStep: t,
  backButton: e,
  nextButton: o
};
export {
  e as backButton,
  t as completedStep,
  n as default,
  o as nextButton
};
